import { useEffect, useState, Suspense } from 'react';
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import { BrowserRouter, Route, Switch, Link, NavLink, useParams, useRouteMatch, useHistory, useLocation, Redirect } from 'react-router-dom';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import { Button, Grid, Box, Container, Typography, Pagination, PaginationItem } from '@mui/material'
import { format } from 'date-fns'

import { Sound, Movie, File, MultiLineBody } from '../utils/util'
import { CONFIG } from '../states/settings'


const Item = (props) => {
  let json_file  = props.json_file  ? props.json_file  : null
  let from_url   = props.from_url   ? props.from_url   : '/'
  //console.log('参照元URL -> ', from_url)

  let [ item,  setItem  ] = useState()
  let [ items, setItems ] = useState([])
  let { id,    entry_id } = useParams()

  let ui = useLocation()
  let page_limit = ui.state ? (ui.state.page_limit ? ui.state.page_limit : CONFIG.LIMIT_PER_PAGE) : CONFIG.LIMIT_PER_PAGE


  let render = (item) => {
    if (!item) { return }

    let index_this = items.findIndex(ele => ele.id == item.id)
    let pagenum_this = (index_this / page_limit >> 0) + 1
    let url = `${CONFIG.PAGE_ROOT_PATH}/${id}/${pagenum_this}`


    let ClickTop = ()=>{
      return (
        <Link to={`${CONFIG.PAGE_ROOT_PATH}/`}>
          <Button variant='contained' size='large'>Topページへ戻る</Button>
        </Link>
      )
    }

    let ClickBack = ()=>{
      return (
        // 直前のページに戻る
        // <Link to={`${from_url}`}>
        <Link to={{
          pathname: url,
          state: {
            from_entry_id: item.id
          }
        }}>
          <Button variant='contained' size='large'>記事リストへ戻る</Button>
        </Link>
      )
    }

    let ClickBackToSource = ()=>{
      const fromUrl = ui.state?.from_url || '/';
      const searchQuery = ui.state?.search_query;
      const archiveType = ui.state?.archive_type;
      
      // console.log('ClickBackToSource - fromUrl:', fromUrl);
      // console.log('ClickBackToSource - searchQuery:', searchQuery);
      // console.log('ClickBackToSource - archiveType:', archiveType);
      
      if (fromUrl === '/search' && searchQuery) {
        return (
          <Link to={{
            pathname: `${CONFIG.PAGE_ROOT_PATH}/search`,
            state: { search_query: searchQuery }
          }}>
            <Button variant='outlined' size='large' sx={{ ml: 1 }}>
              🔍 検索結果に戻る
            </Button>
          </Link>
        )
      } else if (fromUrl.includes('/archive/') || archiveType) {
        return (
          <Link to={fromUrl}>
            <Button variant='outlined' size='large' sx={{ ml: 1 }}>
              📅 アーカイブに戻る
            </Button>
          </Link>
        )
      } else if (fromUrl !== '/') {
        return (
          <Link to={fromUrl}>
            <Button variant='outlined' size='large' sx={{ ml: 1 }}>
              ← 前のページに戻る
            </Button>
          </Link>
        )
      }
      return null;
    }

    return (
      <Box
        className={`item_detail_wrapper ${item.is_emergency ? 'emergency' : ''}`}
      >
        <Typography component="h4" variant="h5" fontWeight='600' mb='.5rem'>
          { item.title }
        </Typography>
        
        <Grid container mb='1.5rem' ml='.2rem'>
          <p className='sender_name'>{ item.sender_name }</p>
          <time className='time_c1' dateTime={format(new Date(item.sent_at),'yyyy-MM-dd HH:mm')}>{ format(new Date(item.sent_at),'yyyy-MM-dd HH:mm') }</time>
        </Grid>

        <Sound item={ item.sound_file ? item.sound_file : (item.generated_sound_file ? item.generated_sound_file : null)} />

        {/* <p>{ item.body }</p> */}
        <Typography component="p" variant="h7" mb='1rem' sx={{ fontSize:'1.1rem', lineHeight:'1.6', letterSpacing:'1.0px' }}>
          <MultiLineBody body={item.body} />
        </Typography>

        {/* <p>IS_EMERGENCY: { item.is_emergency.toString() }</p> */}
        {/* <p>MOVIE: { item.generated_sound_file }</p> */}
        {/* <p>TYPE: { item.type }</p> */}
        <Movie item={ item.movie_url  } />
        <File  item={ item.file } />

        <Box mt='3rem' className='btns_pg_detail'>
          <ClickTop />
          <ClickBackToSource />
          {/* <ClickBack /> */}
        </Box>
      </Box>
    )
  }

  let PagerOneByOne = ()=>{
    if ( !(item && items.length>0) ) { return }

    // 年月ページや検索ページからの遷移の場合は非表示
    const archiveType = ui.state?.archive_type;
    const isArchivePage = ui.state?.from_url?.includes('/archive/');
    const isSearchPage = ui.state?.from_url === '/search';
    
    if (archiveType || isArchivePage || isSearchPage) {
      // 年月・検索ページからの遷移では前後記事ナビゲーションを非表示
      // ただし余白を維持するために空のBoxを返す
      return <Box sx={{ height: '1rem' }} />;
    }

    let current_page = items.findIndex(ele => ele.id == item.id) + 1

    let changeCurrentPage = (e, page)=>{
      setItem(items[page-1])
    }

    let PrevElement = (cls)=>{
      let p
      if ( (p = current_page-1) <= 0 ){
        return <span></span>
      }

      // 配列index調整
      p--
      // useStateの更新だとURLが変わらないため、Linkに変更
      return <Link to={`${CONFIG.PAGE_ROOT_PATH}/${id}/items/${items[p].id}`}>
               <ArrowBackRoundedIcon className='prev-icon' /><span style={{fontSize:'1.1rem'}}>{items[p].title}</span>
             </Link>
      //return <span style={{textDecoration:'underline'}}><ArrowBackRoundedIcon sx={{verticalAlign:'middle',margin:'0 1rem 0 0'}} />{items[p].title}</span>
    }

    let NextElement = (cls)=>{
      let p
      if ( (p = current_page) >= items.length ) {
        return <span></span>
      }

      // useStateの更新だとURLが変わらないため、Linkに変更
      return <Link to={`${CONFIG.PAGE_ROOT_PATH}/${id}/items/${items[p].id}`}>
               <span style={{fontSize:'1.1rem'}}>{items[p].title}</span><ArrowForwardRoundedIcon className='next-icon' />
             </Link>
      // return <span style={{textDecoration:'underline'}}>{items[p].title}<ArrowForwardRoundedIcon sx={{verticalAlign:'middle',margin:'0 0 0 1rem'}}/></span>
    }


    return (
        <Pagination
          className='custom_pagination'
          count={items.length}
          defaultPage={current_page}
          siblingCount={0}
          boundaryCount={0}
          size="large"
          variant='outlined'
          color='primary'
          onChange={ changeCurrentPage }
          sx={{ margin:'1rem 0 1.25rem', borderBottom:'1px solid #c9c9c9', padding:'0 0 1rem' }}
          renderItem={(item) => <PaginationItem {...item} components={{next:NextElement, previous:PrevElement}}/>}
        />
    )
  }


  useEffect(() => {
    if ( !json_file ) return;
  
    (async () => {
      try {
        let url =  CONFIG.API.INFO + json_file.split('.')[0] + CONFIG.API.INFO_EX
        let response = await fetch(url);
        
        if (!response.ok) {
          console.warn('記事詳細のHTTPエラー:', response.status, response.statusText);
          return;
        }
        
        const contentType = response.headers.get('content-type');
        if (!contentType || !contentType.includes('application/json')) {
          console.warn('記事詳細のContent-Typeエラー:', contentType);
          return;
        }
        
        let json = await response.json()

        let entries = json.messages || []
        let entry = entries.find(v=>v.id == entry_id)

        setItem(entry)
        setItems(entries)
      } catch (error) {
        console.warn('記事詳細の取得エラー:', error);
      }
    })();
  }, [])


  return (
    <>
      <PagerOneByOne />
    {
      render(item)
    }
    </>
  );
}


export default Item;
